import React, { useState } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'react-bootstrap';
import { MdMoreHoriz } from 'react-icons/md';
import SendTicketModal from '../../../Modals/SendTicketModal/SendTicketModal';

function TicketListItem(props) {
    const { ticket } = props;
    const [ modalShow, setModalShow ] = useState(false);
    const { t } = useTranslation();

    const _openTicket = () => window.open(ticket.ticketUrl, '_blank');

    return (
        <React.Fragment>
            <div className="DataListItem row align-items-center" key={ticket.ticketID} style={{paddingTop: '20px', paddingBottom: '20px'}}>
                <div className="col-lg-5" onClick={_openTicket}>
                    <span style={{ cursor: 'pointer', fontWeight: 'bold' }}>{ticket.productName}</span>
                    <p>{ticket.ticketID}</p>
                </div>
                <div className="col-lg-5 text-left">
                    {moment(ticket.timeCreated).format('DD.MM.YYYY - HH:mm') || ''}
                </div>
                <div className="col text-right">
                    <Dropdown>
                        <Dropdown.Toggle as="span">
                            <MdMoreHoriz style={{fontSize: '18px'}} />
                        </Dropdown.Toggle>
                        <Dropdown.Menu alignRight>
                            <Dropdown.Item onClick={_openTicket}>
                                {t('general.open')}
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => {setModalShow(true)}}>
                                {t('general.send')}
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <SendTicketModal
                    ticketID={ticket.ticketID}
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                />
            </div>
        </React.Fragment>
    )
}

export default TicketListItem;